/*****************************************************************
 * DO NOT MANUALLY EDIT THIS FILE!                               *
 *                                                               *
 * This file is auto-generated by 'yarn prepare'                 *
 *****************************************************************/

export const currencySignMap: { [k: string]: string } = {
  usd: '$',
  nzd: '$',
  aud: '$',
  gbp: '£',
  hkd: '$',
  sgd: '$',
  php: '₱',
  eur: '€',
  cad: '$',
  zar: 'R',
  inr: '₹',
  jmd: '$',
  clp: '$',
  mxn: '$',
  idr: 'Rp',
  myr: 'RM',
  sek: 'kr',
  jpy: '¥',
  pln: 'zł',
  brl: 'R$',
  cny: '￥',
  dkk: 'kr',
  vnd: '₫',
  aed: 'د.إ',
  ars: '$',
  bdt: '৳',
  cop: '$',
  pkr: 'Rs',
  chf: 'Fr.',
  huf: 'Ft',
  ils: '₪',
  krw: '₩',
  nok: 'kr',
  qar: 'ر.ق',
  ron: 'lei',
  rub: 'руб',
  sar: 'ر.س',
  thb: '฿',
  try: '₺',
};
